import styled, { css } from 'styled-components';

interface IExpandButtonProps {
  $hidden?: boolean;
}

export const StyledExpandButton = styled.button<IExpandButtonProps>(
  props => css`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;

    &.focus-visible {
      outline: ${props.theme.text.linkExternalHover} dotted 1px;
      outline: -webkit-focus-ring-color auto 1px;
    }

    ${props.$hidden &&
    css`
      display: none;
    `}
  `
);
